var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-container wrap_over"},[_c('div',{staticClass:"dashboard-text"},[_vm._v("歡迎使用快遞代收管理系統"),_c('span',{staticClass:"dashboard-text-version"},[_vm._v("(v-"+_vm._s(_vm.packageJSON.version)+")")])])])}
var staticRenderFns = []

export { render, staticRenderFns }